import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ProjectTechstackService {
  private apiUrl = environment.apiUrl;
  httpOptions = {
    headers: new HttpHeaders(
      {
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
    ),
  };
  constructor(private http: HttpClient) {

  }

  getCompetenciesData() {
    const url = `${this.apiUrl}Competency/GetCompetenciesData`;
    return this.http.get(url);
  }
  getProjectCompetenciesData() {
    const url = `${this.apiUrl}Competency/GetProjectCompetenciesData`;
    return this.http.get(url);
  }
  getCustomersData() {
    const url = `${this.apiUrl}Competency/GetClients`;
    return this.http.get(url, this.httpOptions);
  }
  getProjectsData(clinetId: number) {
    const url = `${this.apiUrl}Competency/GetProjectsById?clintId=` + clinetId;
    return this.http.get(url, this.httpOptions);
  }
  getProjectTechstack(clinetId: number, projectId: number, managerId: number) {
    const url = `${this.apiUrl}Competency/GetProjectTechstack?clientId=${clinetId}&projectId=${projectId}&managerId=${managerId}`;
    return this.http.get(url, this.httpOptions);
  }
  getSkillsets(competencyId: number) {
    const url = `${this.apiUrl}Competency/GetCompetencySkills?competencyId=${competencyId}`;
    return this.http.get(url, this.httpOptions);
  }
  addOrUpdateProjectTechstack(projectCompetencyData: any) {
    const url = `${this.apiUrl}Competency/AddOrUpdateProjectTechstack`;
    return this.http.post(url, projectCompetencyData, this.httpOptions);
  }
}
